var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12 6.5v-5h-6c-1.65685 0-3 1.34315-3 3v16c0 1.6569 1.34315 3 3 3h12c1.6569 0 3-1.3431 3-3v-11h-6c-1.6569 0-3-1.34315-3-3zm2 0v-4.44396c.073.052.144.10742.2125.16619l5.7399 4.91987c.1284.11005.2462.22988.3529.3579h-5.3053c-.5523 0-1-.44772-1-1zm-6 4.5c-.55228 0-1 .4477-1 1v2h2v-1h2v6.5h-1v2h4v-2h-1v-6.5h2v1h2v-2c0-.5523-.4477-1-1-1z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconText);
export default __webpack_public_path__ + "static/media/icon-text.3096b1d98b77eb89edd52297666d1d27.svg";
export { ForwardRef as ReactComponent };